<div class="flex flex-col gap-4">
  <p-card header="Usługi dostępne po zalogowaniu" tabindex="0" role="note">
    <p-card header="Dla świadczeniobiorców" tabindex="0" role="note">
      <ul class="space-y-2">
        @for (item of SWIADCZENIOBIORCY_MENU_ITEM; track item) {
          <li class="flex items-center link">
            <button
              (click)="onCardClick(item.state?.['section'])"
              (keyup.enter)="onCardClick(item.state?.['section'])"
            >
              <i class="pi pi-info-circle mr-2"></i>
              <span class="hover:underline cursor-pointer">{{
                item.label
              }}</span>
            </button>
          </li>
        }
      </ul>
    </p-card>
    <br />
    <p-card header="Dla przedsiębiorców" tabindex="0" role="note">
      <ul class="space-y-2">
        @for (item of PRZEDZSIEBIORCY_MENU_ITEM; track item) {
          <li class="flex items-center link">
            <button
              (click)="onCardClick(item.state?.['section'])"
              (keyup.enter)="onCardClick(item.state?.['section'])"
            >
              <i class="pi pi-info-circle mr-2"></i>
              <span class="hover:underline cursor-pointer">{{
                item.label
              }}</span>
            </button>
          </li>
        }
      </ul>
    </p-card>
  </p-card>
</div>
